import * as React from "react";
import {FontAwesomeIcon}        from "@fortawesome/react-fontawesome";
import {faArrowRightToBracket, faArrowRight} from "@fortawesome/free-solid-svg-icons";

import "./ai-wizard-flyout.scss";

import { cs }                from "@Common/react/chain-services";
import {UseState}            from "@Common/react/use-state";
import {Load2}               from "@Common/react/load2";
import {consumeContext}      from "@Common/react/context";
import {isDevXd}             from "@Common/ui-components/debug/is-dev";
import { ButtonSpinner }     from "@Common/ui-components/loading-spinners/button-spinner";
import { ScreenLoader }      from "@Common/ui-components/loading-spinners/screen-loader";

export const AiWizard = ({ children, idOrder, isWizardFlyoutOpen, preventBackgroundScroll = true, errorInWizard }) => cs(
    consumeContext("apis"),
    consumeContext("session"),
    consumeContext("userLevels"),
    ["state", ({ session }, next) => UseState({
        defaultValue: session.value,
        next,
    })],
    ["isInternalUser", ({userLevels}, next) => next(userLevels?.internalUser)],
    ["closeFlyout", ({}, next) => next(() => {
        isWizardFlyoutOpen.onChange(false);
    })],
    ["isDevModeOn", ({isInternalUser}, next) => next(isInternalUser && isDevXd())],
    ({isDevModeOn, closeFlyout}) => (
        (true ?
            <div className={(preventBackgroundScroll && isWizardFlyoutOpen.value) ? "prevent-background-scroll ai-wizard-jg6" : "ai-wizard-jg6"}>
                {/* Using onMouseDown so if a user accidentaly releases a click/drag outside of flyout it isn't closed */}
                {isWizardFlyoutOpen.value ? <div className="wizard-overlay" onMouseDown={() => closeFlyout()}></div> : null}
                <div className={isWizardFlyoutOpen.value ? errorInWizard ? "wizard-flyout visible error" : "wizard-flyout visible" : "wizard-flyout hidden"}>
                    <div className="flyout-dismiss">
                        <FontAwesomeIcon icon={faArrowRight} onClick={() => closeFlyout()}/>
                    </div>
                    {children}
                </div>
            </div>
        : null)
    )
);